module.exports = __webpack_public_path__ + "static/img/video_icon2.9cdf049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/video_icon2.png
// module id = oMp7
// module chunks = 0